import React from "react";
import { Popover, Row, Col, Divider } from "antd";
import { DollarOutlined, WalletOutlined, GiftOutlined } from "@ant-design/icons";

const PaidInfo = ({ paid = 0, giftCardPaid = 0 }) => {
  if (paid <= 0) return null;
  const cashPaid = Math.max(0, paid - giftCardPaid);

  const formatNumber = (num) => {
    if (typeof num !== "number" || isNaN(num)) return "--";
    return parseFloat(num.toFixed(2));
  };

  const blockStyle = {
    textAlign: "center",
    padding: "0 12px",
  };

  const labelStyle = {
    fontSize: "0.8rem",
    color: "var(--ion-color-step-500)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    marginBottom: 4,
  };

  const amountStyle = {
    fontSize: "1.1rem",
    fontWeight: "bold",
    color: "black",
  };

  const blocks = [];

  if (cashPaid > 0) {
    blocks.push(
      <Col key="cash" style={blockStyle}>
        <div style={labelStyle}>
          <WalletOutlined />
          Cash
        </div>
        <div style={amountStyle}>${formatNumber(cashPaid)}</div>
      </Col>
    );
  }

  if (giftCardPaid > 0) {
    if (blocks.length > 0) {
      blocks.push(<Divider key="divider-gift" type="vertical" style={{ height: "100%", margin: "0 8px" }} />);
    }
    blocks.push(
      <Col key="gift" style={blockStyle}>
        <div style={labelStyle}>
          <GiftOutlined />
          Gift Card
        </div>
        <div style={amountStyle}>${formatNumber(giftCardPaid)}</div>
      </Col>
    );
  }

  // Always show total
  if (blocks.length > 0) {
    blocks.push(<Divider key="divider-total" type="vertical" style={{ height: "100%", margin: "0 8px" }} />);
  }

  blocks.push(
    <Col key="total" style={blockStyle}>
      <div style={labelStyle}>
        <DollarOutlined />
        Total
      </div>
      <div style={amountStyle}>${formatNumber(paid)}</div>
    </Col>
  );

  return (
    <Popover content={<Row justify="center" align="middle">{blocks}</Row>} trigger="hover">
      <a>{formatNumber(paid)}</a>
    </Popover>
  );
};

export default PaidInfo;
